import { APIcaller } from './APIcaller';

export const createIntercomContact = () => APIcaller.apiPost('/intercom/create-contact', {});
